import { prop, define, useCraftProp } from "@/components/builder/utils";

import ContentEditable from "../utils/ContentEditable";

import BasePreview from "./base";

function LabelPreview({ ...props }) {
  const { value, setValue } = useCraftProp('content')

  return <BasePreview {...props}>
    <ContentEditable
      html={value}
      onChange={setValue}
      tagName='div'
    />
  </BasePreview>
}

function LabelHTML({ content, attributes }) {
  return <label {...attributes}>
    {content}
  </label>
}

export default define('label', LabelPreview, LabelHTML)
  .canSave()
  .property(prop.stylePattern())
  .property(prop.new('Content', 'content').hide().own())
  .property(prop.predefined.customClass())
  .property(...prop.predefined.typography())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(prop.predefined.letterSpacing())
  .property(prop.predefined.lineHeight())
  .property(prop.predefined.textAlign())
  .property(prop.predefined.textShadow())
  .property(prop.predefined.attributes())
  .defaultProps({
    fontSize: 'sm',
    textColor: 'gray-700',
  })
  .build()
